import { CSSProperties, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import progressClasses from '@/components/radial-progress.module.css';
import {
  VIDEO_MIN_LENGTH,
  VIDEO_MAX_LENGTH,
} from '@/pages/Answers/constants.ts';
import {
  RecordControlButton,
  type RecordControlProps,
} from './RecordControlButton';

/**
 * Original control: a radial ring around the button fills as the recording
 * approaches VIDEO_MIN_LENGTH, and the label counts the remaining seconds.
 */
export const RecordControlRing: FC<RecordControlProps> = (props) => {
  const { isRecording, timeLeft } = props;
  const { t } = useTranslation();

  const isDisabled =
    isRecording && VIDEO_MAX_LENGTH - timeLeft < VIDEO_MIN_LENGTH;

  const progress = isDisabled
    ? Math.min(((VIDEO_MAX_LENGTH - timeLeft + 1) / VIDEO_MIN_LENGTH) * 100, 100)
    : 0;

  return (
    <div
      className={cn(
        progressClasses['radial-progress'],
        progress === 0 ? progressClasses['reset'] : '',
        'absolute -top-8 text-[#569de5]'
      )}
      style={
        {
          '--value': progress,
          '--size': '100px',
          '--thickness': '5px',
        } as CSSProperties
      }
    >
      <RecordControlButton
        {...props}
        isDisabled={isDisabled}
        recordingLabel={
          <span key={timeLeft}>
            {t('record_button.stop')}
            <br />
            <span>
              {timeLeft} {t('record_button.sec')}
            </span>
          </span>
        }
      />
    </div>
  );
};

export default RecordControlRing;
